export default __webpack_public_path__ + "static/media/ROM CLASS-6_SYLLABUS_2025-26.a3739a44.pdf";